import { DATA_SERVICE_BASE_URL } from '../ApiService';
import { fetchWithAuth } from '../AuthService';

/**
 * Analytics Overview API — communicates with the AI-Service analytics overview
 * endpoint via the data-service proxy at /api/proxy/ai-service/api/analytics/*.
 *
 * Also includes direct data-service calls for analytics snapshot data.
 */
const AI_BASE = `${DATA_SERVICE_BASE_URL}/api/proxy/ai-service/api/analytics`;
const ADMIN_BASE = `${DATA_SERVICE_BASE_URL}/api/admin/analytics`;
const STUDENT_BASE = `${DATA_SERVICE_BASE_URL}/api/student/analytics`;

export const AnalyticsOverviewApi = {

  /**
   * Generate an admin platform-wide AI analytics overview.
   * @param {number} days - Lookback period in days (default 30)
   */
  async getAdminOverview(days = 30, context) {
    let url = `${AI_BASE}/overview?scope=admin&days=${days}`;
    if (context) url += `&context=${encodeURIComponent(context)}`;
    const res = await fetchWithAuth(url);
    if (!res.ok) throw new Error(`Admin overview failed: ${res.status}`);
    return res.json();
  },

  /**
   * Generate a per-user AI analytics overview.
   * @param {number} userId - User ID
   * @param {number} days - Lookback period in days (default 30)
   */
  async getUserOverview(userId, days = 30) {
    const res = await fetchWithAuth(`${AI_BASE}/overview?scope=user&userId=${userId}&days=${days}`);
    if (!res.ok) throw new Error(`User overview failed: ${res.status}`);
    return res.json();
  },

  /**
   * Get the raw admin analytics snapshot (no AI generation).
   * @param {string} from - ISO date string
   * @param {string} to - ISO date string
   */
  async getAdminSnapshot(from, to) {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    const res = await fetchWithAuth(`${ADMIN_BASE}/snapshot?${params}`);
    if (!res.ok) throw new Error(`Admin snapshot failed: ${res.status}`);
    return res.json();
  },

  /**
   * Get the raw user analytics snapshot (no AI generation).
   * @param {number} days - Lookback period in days
   */
  async getUserSnapshot(days = 30) {
    const res = await fetchWithAuth(`${STUDENT_BASE}/snapshot?days=${days}`);
    if (!res.ok) throw new Error(`User snapshot failed: ${res.status}`);
    return res.json();
  },

  /**
   * Trigger all aggregation jobs (admin only).
   */
  async triggerAggregateAll() {
    const res = await fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/jobs/aggregate-all`, {
      method: 'POST'
    });
    if (!res.ok) throw new Error(`Aggregate-all failed: ${res.status}`);
    return res.json();
  }
};
